export const PRICING_PAGE_LINK = 'https://www.hotjar.com/pricing/';
